
export const MBL = 'MBL'
export const MBL2 = 'MBL2'
export const HBL = 'HBL'
export const HBL2 = 'HBL2'
export const AMS = 'AMS'
export const MAWB = 'MAWB'
export const HAWB = 'HAWB'
export const HAWB2 = 'HAWB2'// 形式分单
export const AFR = 'AFR'
export const THAILAND = 'THAILAND' // 泰国舱单

export const MSC = 'MSC'

export const AMS_NEW = 'AMS_NEW'
export const AFR_NEW = 'AFR_NEW'

export const MBLs = [MBL, MBL2]
export const HBLs = [HBL, HBL2, HAWB, HAWB2]

export function mblExist(docType) {
  for (const str in MBLs) {
    if (str === docType) { return true }
  }
  return false
}

export function hblExist(docType) {
  for (const str in HBLs) {
    if (str === docType) { return true }
  }
  return false
}
